import { Component } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { guestExtraNotificationMessages, userExtraNotificationMessages } from './messages'
import { selectAllExtraCategories } from '@tokeet-frontend/extras'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-extra-automation-wizard',
  templateUrl: './extra-automation-wizard.component.html',
  styleUrls: ['./extra-automation-wizard.component.scss'],
})
export class ExtraAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Extra

  guestNotificationMessages = guestExtraNotificationMessages
  userNotificationMessages = userExtraNotificationMessages

  categories$ = this.store.pipe(select(selectAllExtraCategories))

  constructor(protected fb: FormBuilder, protected actions: Actions, protected store: Store<any>) {
    super(actions, store, fb)

    this.form.patchValue({ event: AutomationEventTypes.ExtraCreated })
  }
}
